export default (editor, config = {}) => {
  const bm = editor.BlockManager;
  bm.add('web_widget', {
    label: 'Web',
    category: 'Widget',
    content: {
      activeOnRender: 1,
      resizable: {
        step: 0.2,
        minDim: 10,
        maxDim: 100,
        currentUnit: 1,
        autoHeight: true
      },
      void: true,
      type: 'web_widget',
      style: {
        width: '30%',
        height: '30%'
      }
    },
    attributes: {
      class: 'fa fa-globe' //icon in the panel
    }
  });
};



// WEBPACK FOOTER //
// ./src/plugins/web/blocks.js